module.exports = __webpack_public_path__ + "static/media/sidebar.c963330b.jpg";